<template>
  <div class="card">
    <div class="flex justify-content-between align-items-center mb-4">
      <h2>Mermas</h2>
      <Button label="Nueva Merma" icon="pi pi-plus" class="p-button-success" @click="nuevaMerma" v-if="auth && 'Merma Crear' in auth.user.permissions" />
    </div>

    <!-- Contenido de MermaList -->
    <CustomDataTable 
    :datos="mermas"
    :columnas="columnasMermas"
    :cargando="cargando"
    nombreEntidad="mermas"
    dataKey="id"
    >
     <!-- 1. Slot para formatear la columna 'fecha' -->
    <template #fecha="{ data }">
      {{ formatFecha(data.fecha) }}
    </template>
    <!-- 2. Slot para formatear la columna 'estado' con los Badges -->
    <template #estado="{ data }">
        <span :class="'product-badge ' + (data.estado == 1 ? 'status-instock' : 'status-outofstock')">
          {{ data.estado == 1 ? 'Activo' : 'Inactivo' }}
        </span>
      </template>
    <!-- 3. Slot para la columna de ACCIONES -->
    <template #acciones="{ data }">
      <Button
        icon="pi pi-pencil"
        class="p-button-rounded p-button-warning p-button-text mr-2"
        @click="editarMerma(data)"
        v-if="auth && 'Merma Editar' in auth.user.permissions"
      />
      <Button
        icon="pi pi-trash"
        class="p-button-rounded p-button-danger p-button-text"
        @click="confirmarEliminarMerma(data)"
        v-if="auth && 'Merma Eliminar' in auth.user.permissions"
      />
    </template>
    </CustomDataTable>

    <!-- Modal para Crear/Editar -->
    <MermaCreate 
      :mostrar="mostrarModal" 
      :mermaEdit="mermaActual" 
      @closeModal="mostrarModal = false" 
      @actualizarListado="cargarMermas" 
    />

    <!-- Modal Confirmar Eliminar -->
    <ZapiModalShell
      v-model:visible="deleteMermaDialog"
      title="Confirmar"
      width="450px"
      @confirm="deleteMerma"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <p v-if="mermaActual"
          ><strong>Estás Seguro de Eliminar la Merma seleccionada? </strong></p
        >
      </div>
      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-success p-button-lg"
          @click="deleteMermaDialog = false"
        />
        <Button
          label="Si Eliminar"
          icon="pi pi-check"
          class="p-button-danger p-button-lg"
          @click="deleteMerma"
        />
      </template>
    </ZapiModalShell>

    <!-- Modal Advertencia Activo -->
    <ZapiModalShell
      v-model:visible="advertenciaDialog"
      title="Acción no permitida"
      width="450px"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-info-circle mr-3 text-yellow-500" style="font-size: 2rem" />
        <p>No se puede eliminar una merma <strong>Activa</strong>. Cambie su estado a inactivo primero.</p>
      </div>
      <template #footer>
        <div class="flex justify-content-center w-full">
          <Button
            label="Entendido"
            icon="pi pi-check"
            class="p-button-primary p-button-lg"
            @click="advertenciaDialog = false"
          />
        </div>
      </template>
    </ZapiModalShell>
  </div>
</template>

<script>
import MermaService from '@/service/MermaService';
import CustomDataTable from '@/components/shared/CustomDataTable.vue';
import MermaCreate from './MermaCreate.vue';
import ZapiModalShell from '@/components/shared/ZapiModalShell.vue';
import { useAuth } from '@/stores';

export default {
  name: 'MermaList',
  components: {
    CustomDataTable,
    MermaCreate,
    ZapiModalShell
  },
  data() {
    return {
      mermas: [],
      cargando: false,
      mostrarModal: false,
      deleteMermaDialog: false,
      advertenciaDialog: false,
      mermaActual: {},
      mermasService: null,
      columnasMermas:[
       { field: 'id', header:'ID', sortable: true},
       { field: 'sucursal.nombre', header:'SUCURSAL', sortable: true},
       { field: 'producto.descripcion', header: 'PRODUCTOS', sortable: true},
       { field: 'tipo_merma.descripcion', header: 'TIPO DE MERMA'},
       { field: 'cantidad_gramos', header:'CANTIDAD (GR)'},
       { field: 'cantidad_unidad', header: 'CANTIDAD (UNI)'},
       { field: 'observacion', header: 'OBSERVACION'},
       { field: 'fecha', header: 'FECHA'},
       { field: 'estado', header: 'ESTADO'},
       
      ]
    }
  },
  auth: null,
  created(){
    this.auth = useAuth();
    this.mermasService = new MermaService();
  },
  mounted() {
    this.cargarMermas();
  },
  methods: {
    /**
     * Carga las mermas desde el servicio
     */
    async cargarMermas() {
      this.cargando = true;
      try {
        const response = await this.mermasService.getAll();
        
        // Aplanamos las propiedades anidadas y mapeamos el estado a 1 o 0
        const datosCrudos = response.data || response;
        this.mermas = datosCrudos.map(merma => {
          const est = merma.estado;
          const estadoNumerico = (est === 1 || est === '1' || String(est).toUpperCase() === 'ACTIVO') ? 1 : 0;
          
          return {
            ...merma,
            estado: estadoNumerico, // Forzamos a que sea 1 o 0 en todo el frontend
            'sucursal.nombre': merma.sucursal ? merma.sucursal.nombre : '',
            'producto.descripcion': merma.producto ? merma.producto.descripcion : '',
            'tipo_merma.descripcion': merma.tipo_merma ? merma.tipo_merma.descripcion : ''
          };
        });
      } catch (error) {
        console.error(error);
        this.$toast.add({
          severity:'error',
          summary:'Error',
          detail:"error al cargar la data",
          life: 3000
          });
      } finally {
        this.cargando = false;
      }
    },

    /**
     * 
     */
    nuevaMerma() {
      this.mermaActual = {};
      this.mostrarModal = true;
    },
    editarMerma(merma) {
      this.mermaActual = merma;
      this.mostrarModal = true;
    },
    confirmarEliminarMerma(merma) {
      if (merma.estado === 1 || merma.estado === '1' || String(merma.estado).toUpperCase() === 'ACTIVO') {
        this.advertenciaDialog = true;
        return;
      }
      this.mermaActual = { ...merma };
      this.deleteMermaDialog = true;
    },
    async deleteMerma() {
      try {
        await this.mermasService.delete(this.mermaActual.id);
        this.mermas = this.mermas.filter(m => m.id !== this.mermaActual.id);
        this.$toast.add({severity:'success', summary: 'Éxito', detail: 'Merma eliminada', life: 3000});
        this.deleteMermaDialog = false;
        this.mermaActual = {};
      } catch (error) {
        console.error("Error al eliminar", error);
        this.$toast.add({severity:'error', summary: 'Error', detail: 'Ocurrió un error al eliminar', life: 3000});
      }
    },
    formatFecha(fecha) {
      if (!fecha) return "";
      // Formateo básico de fecha, ajusta según necesites
      return new Date(fecha).toLocaleDateString();
    }
  },
  
}
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
/* Estilos básicos para los badges de estado similares a los de PrimeVue */
.customer-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;
}
.customer-badge.status-qualified {
    background: #C8E6C9;
    color: #256029;
}
.customer-badge.status-unqualified {
    background: #FFCDD2;
    color: #C63737;
}
</style>